/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import React, { useEffect, useRef, useState } from "react";
import { Modal, Form, Dropdown, Spinner } from "react-bootstrap";
import swal from "sweetalert";
import { Pagination } from "antd";
import { GlobalFilter } from "../components/table/FilteringTable/GlobalFilter";
import {
  addUserProfile,
  changePwdService,
  changeUserStatus,
  deleteUser,
  fetchAllUsers,
  resetPwd,
} from "../../services/UserServices";
import { getBase64 } from "./Registration";
import formatError from "../../services/FormatError";
import { fetchAllRoles } from "../../services/RolesServices";
import { useTranslation } from "react-i18next";
import { MultiSelect } from "react-multi-select-component";
import { globalFileUploader } from "../components/UIComponents/uploader";
import { useLoadScript, StandaloneSearchBox } from "@react-google-maps/api";


export const isObjectEmpty = (objectName) =>
  Object.keys(objectName).length === 0;

export const sortList = (data) => data.sort((a, b) => a.id - b.id);
const libraries = ["places"];

function Users() {
    const { isLoaded } = useLoadScript({
      googleMapsApiKey: "AIzaSyB3n919-1MbNDn_jkTYcM0v4wVCoAWxRA0",
      libraries,
    });
  const { t } = useTranslation();
  const otherInterest = [
    {
      label: t("hvolunteering"),
      children: [],
    },
    {
      label: t("hprofessionalAssociation"),
      children: [],
    },
    {
      label: t("hpolitics"),
      children: [],
    },
    {
      label: "Sports",
      children: [
        {
          label: "Basket-ball",
          value: "Basket-ball",
        },
        {
          label: "Football",
          value: "Football",
        },
        {
          label: "Soccer",
          value: "Soccer",
        },
        {
          label: "Baseball",
          value: "Baseball",
        },
        {
          label: "Golf",
          value: "Golf",
        },
        {
          label: "Tennis",
          value: "Tennis",
        },
      ],
    },
    {
      label: "Outooring  activities",
      children: [
        {
          label: "Kayak",
          value: "Kayak",
        },
        {
          label: "Biking",
          value: "Biking",
        },
        {
          label: "Hicking",
          value: "Hicking",
        },
        {
          label: t("halpineSki"),
          value: "Alpine ski",
        },
        {
          label: t("hcrossSki"),
          value: "Crosscountry ski",
        },
      ],
    },
    {
      label: "Theater - Movies",
      children: [
        {
          label: "Drama",
          value: "Drama",
        },
        {
          label: "Suspense",
          value: "Suspense",
        },
        {
          label: t("horror"),
          value: "Horror",
        },
        {
          label: t("comedy"),
          value: "Comedy",
        },
      ],
    },
    {
      label: "Dance",
      children: [
        {
          label: "Hip Hop",
          value: "Hip Hop",
        },
        {
          label: "Latin",
          value: "Latin",
        },
        {
          label: "Social",
          value: "Social",
        },
        {
          label: "Disco",
          value: "Disco",
        },
        {
          label: "Ballet",
          value: "Ballet",
        },
      ],
    },
  ];

  const ctxObj = JSON.parse(sessionStorage.getItem("userDetails"));
  const [showPwd, setShowPwd] = useState(false);
  const [showNewPwd, setShowNewPwd] = useState(false);

  const [usersList, setUsersList] = useState({
    original: [],
    filtered: [],
  });
  const [isIterestItemsShow, setIsIterestItemsShow] = useState(false);
  const [subInterest, setSubInterest] = useState([]);
  const [selectedOtherInterest, setSelectedOtherInterest] = useState("");
  const [selectedSubInterest, setSelectedSubInterest] = useState([]);

  const [allRoles, setAllRoles] = useState([]);

  const [gridFilter, setGridFilter] = useState("");

  const [addUser, setAddUser] = useState(false);

  const [firstname, setFirstname] = useState("");

  const [lastname, setLastname] = useState("");

  const [username, setUsername] = useState("");

  const [password, setPassword] = useState("");

  const [confirmPwd, setConfirmPwd] = useState("");

  const [idRole, setIdRole] = useState("");

  const [phone, setPhone] = useState("");

  const [email, setEmail] = useState("");

  const fileInputRef = useRef(null);

  const [selectedFile, setSelectedFile] = useState(null);

  const [base64, setBase64] = useState("");

  const [address, setAddress] = useState("");

  const [city, setCity] = useState("");

  const [country, setCountry] = useState("");
  const [profession, setProfession] = useState("");

  const [createTriggered, setCreateTriggered] = useState(false);

  const [viewData, setViewData] = useState({});

  const [updateData, setUpdateData] = useState({});

  const [changePwdModal, setChangePwdModal] = useState({
    cond: false,
    id: "",
  });

  const [changePwd, setChangePwd] = useState({
    oldPwd: "",
    newPwd: "",
  });

  const [changePwdTrigger, setChangePwdTrigger] = useState(false);

  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [userPhoto, setUserPhoto] = useState("");

  useEffect(() => {
    fetchUsersList();
    fetchRoleList();
  }, []);

  useEffect(() => {
    if (!isObjectEmpty(viewData)) {
      updateFormData(viewData);
    } else {
      resetForm();
    }
  }, [viewData]);

  useEffect(() => {
    if (!isObjectEmpty(updateData)) {
      updateFormData(updateData);
    } else {
      resetForm();
    }
  }, [updateData]);

  useEffect(() => {
    fetchUsersList();
  }, [tableParams.current, tableParams.pageSize]);

  const fetchUsersList = () => {
    fetchAllUsers(tableParams.current, tableParams.pageSize)
      .then((res) => {
        const sortedList = sortList(res.data?.result?.data ?? []);

        setUsersList({
          original: sortedList,
          filtered: sortedList,
        });

        setTableParams((prevState) => ({
          ...prevState,
          total: res.data?.result?.count,
        }));
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const fetchRoleList = () => {
    fetchAllRoles()
      .then((res) => {
        const sortedList = sortList(res.data?.result?.data ?? []);
        setAllRoles(sortedList);
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const updateFormData = (data) => {
    setFirstname(data?.firstname);

    setLastname(data?.lastname);

    setUsername(data?.username);

    setIdRole(data?.idrole);

    setPhone(data?.phone);

    setEmail(data?.email);

    setBase64(data?.photo);

    setAddress(data?.address);

    setCity(data?.city);

    setCountry(data?.country);
  };

  const updateGridFilter = (value) => {
    setGridFilter(value);

    if (value !== "") {
      const updatedFilteredData = usersList.original.filter(
        (item) =>
          item.username.toLowerCase().includes(value.toLowerCase()) ||
          (item.hasOwnProperty("email")
            ? item.email.toLowerCase().includes(value.toLowerCase())
            : false) ||
          (item.hasOwnProperty("country")
            ? item.country.toLowerCase().includes(value.toLowerCase())
            : false) ||
          item?.role.toLowerCase().includes(value.toLowerCase())
      );

      setUsersList((prevState) => ({
        ...prevState,
        filtered: [...updatedFilteredData],
      }));
    } else {
      setUsersList((prevState) => ({
        ...prevState,
        filtered: prevState.original,
      }));
    }
  };

  const onHideModal = () => {
    setAddUser(false);

    resetForm();

    setViewData({});

    setUpdateData({});
  };

  const onAddUser = () => {
    setAddUser(true);
  };

  const onChangePhoto = async (e) => {
    const file = e.target.files[0];

    const sizeLimit = 50 * 1024 * 1024; // 50MB

    if (file) {
      const fileType = file.type;

      if (file.size > sizeLimit) {
        swal("Oops", t("hmaxFile"), "error", {
          button: t("htry"),
        });

        fileInputRef.current.value = "";
        setSelectedFile(null);

        setBase64("");

        return;
      }

      // Check if the selected file is of type jpg or png
      if (
        fileType === "image/jpeg" ||
        fileType === "image/jpg" ||
        fileType === "image/png"
      ) {
        setUserPhoto(e.target.files);
      } else {
        fileInputRef.current.value = "";

        setSelectedFile(null);
        setBase64("");

        swal("Oops", t("hselectJpg"), "error", {
          button: t("htry"),
        });
      }
    }
  };

  // address autocomplete 
  const searchBoxRef = useRef(null);

  const [addressInput, setAddressInput] = useState(address || "");

  const handlePlacesChanged = () => {
      console.log(searchBoxRef.current,"adresse")
     if (!searchBoxRef.current) return; // 

      setAddress("");
      setCity("");
      // updateBuyerDetails("region", "");
      // updateBuyerDetails("postalCode", "");
      setCountry("");
      setAddressInput("");
    const places = searchBoxRef.current.getPlaces();
    if (places.length > 0) {
      const place = places[0];
      const addressComponents = place.address_components;

      let address  = "";
      let streetNumber="";
      let route ="";
      let city = "";
      let region = "";
      let postalCode = "";
      let country = "";

      addressComponents.forEach((component) => {
        const types = component.types;

        if (types.includes("street_number")) {
          address = component.long_name ;
        }
        if (types.includes("route")) {
          address = component.long_name;
        }
        if (types.includes("locality")) {
          city = component.long_name;
        }
        if (types.includes("administrative_area_level_1")) {
          region = component.long_name;
        }
        if (types.includes("postal_code")) {
          postalCode = component.long_name;
        }
        if (types.includes("country")) {
          country = component.long_name;
        }
      });
      console.log(address,"adresse")


        setAddressInput(address); // met à jour l'input
      setAddress(address); // met à jour le state global

    //  updateBusinessDetails("address", address);
      setCity(city);
      // updateBuyerDetails("region", region);
      // updateBuyerDetails("postalCode", postalCode);
      setCountry(country);
    }
  };
// End address autocomplete
  const resetForm = () => {
    setFirstname("");

    setLastname("");

    setUsername("");

    setPassword("");

    setConfirmPwd("");

    setIdRole("");

    setPhone("");

    setEmail("");

    fileInputRef.current = null;

    setSelectedFile(null);

    setBase64("");

    setAddress("");

    setCity("");

    setCountry("");
    setProfession("");

    setCreateTriggered(false);
  };

  const addUserHandler = (e, cond) => {
    e.preventDefault();

    if (
      firstname !== "" ||
      lastname !== "" ||
      username !== "" ||
      password !== "" ||
      confirmPwd !== "" ||
      idRole !== ""
    ) {
      addUserProfile(
        {
          id: updateData?.id,
          address,
          city,
          confirmPwd,
          country,
          email,
          firstname,
          idRole,
          lastname,
          password,
          phone,
          username,
          profession,
          otherinterests: selectedOtherInterest,
          subinterests: selectedSubInterest?.map((item) => item.label),
        },
        cond
      )
        .then(async (res) => {
          await globalFileUploader(
            userPhoto,
            "PROFILE_PIC",
            res?.data?.result?.id
          );
          resetForm();
          swal("Success", t("userCreated"), "success");
          setAddUser(false);

          fetchUsersList();
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    } else {
      setCreateTriggered(true);
    }
  };

  const onChangeStatus = (id, status) => {
    swal({
      title: t("hconfirm"),
      text: t("hchangestatut"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
      customClass: {
        popup: "rounded-2xl shadow-lg bg-white p-6",
        title: "text-xl font-bold text-gray-800",
        confirmButton:
          "bg-blue-600 text-white rounded-xl px-6 py-2 hover:bg-blue-700 transition",
      },
    }).then((willaccept) => {
      if (willaccept) {
        changeUserStatus(id, status)
          .then((res) => {
            fetchUsersList();
          })
          .catch((error) => {
            formatError(error.response?.data?.error);
          });
      }
    });
  };

  const onViewUser = (data) => {
    setAddUser(true);
    console.log(data);
    setViewData(data);
  };

  const onUpdateUser = (data) => {
    setAddUser(true);

    setUpdateData(data);
  };

  const onDeleteUser = (id) => {
    swal({
      title: t("hdelete"),
      text: t("hconfirmationDelete"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
      customClass: {
        popup: "rounded-2xl shadow-lg bg-white p-6",
        title: "text-xl font-bold text-gray-800",
        confirmButton:
          "bg-blue-600 text-white rounded-xl px-6 py-2 hover:bg-blue-700 transition",
      },
      buttonsStyling: false,
    }).then((willdelete) => {
      if (willdelete) {
        deleteUser(id)
          .then((res) => {
            fetchUsersList();
          })
          .catch((error) => {
            formatError(error.response?.data?.error);
          });
      }
    });
  };

  const onChangePwd = (id) => {
    setChangePwdModal({
      cond: true,
      id: id,
    });
  };

  const onHideChangePwdModal = () => {
    setChangePwdModal({
      cond: false,
      id: "",
    });

    setChangePwd({
      oldPwd: "",
      newPwd: "",
    });

    setChangePwdTrigger(false);
  };

  const updateChangePwd = (key, value) => {
    setChangePwd((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const changePwdhandler = (e) => {
    e.preventDefault();

    if (changePwd.oldPwd !== "" && changePwd.newPwd !== "") {
      changePwdService(changePwdModal.id, changePwd)
        .then((res) => {
          onHideChangePwdModal();
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    } else {
      setChangePwdTrigger(true);
    }
  };
  const [loadingResetPwd, setLoadingResetPwd] = useState(false);
  const [resetPwdIndex, setResetPwdIndex] = useState(-1);
  const onResetPwd = (id) => {
    setResetPwdIndex(id);
    swal({
      title: t("confirmResetPassword"),
      text: t("confirmResetPasswordDesc"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setLoadingResetPwd(true);
        resetPwd(id)
          .then((res) => {
            swal(t("resetPasswordSuccess"), {
              icon: "success",
            });
            setLoadingResetPwd(false);
          })
          .catch((error) => {
            formatError(error.response?.data?.error);
            setLoadingResetPwd(false);
          });
      }
    });
  };

  const onChangePagination = (page, pageSize) => {
    setTableParams((prevState) => ({
      ...prevState,
      current: page,
      pageSize: pageSize,
    }));
  };

  const onInterestChangeHandler = (e) => {
    if (e.target.value !== "") {
      setSelectedOtherInterest(e.target.value);
      const result = otherInterest.find(
        (item) => item.label === e.target.value
      );
      if (result.children?.length !== 0) {
        setSubInterest(result.children);
        setIsIterestItemsShow(true);
      } else {
        setSelectedSubInterest([]);
        setSubInterest([]);
        setIsIterestItemsShow(false);
      }
    }
  };
   if (!isLoaded) return <div>Loading...</div>;

  return (
    <>
      <Modal className="modal fade" show={addUser} onHide={onHideModal}>
        <div className="" role="document">
          <div className="">
            <form>
              <div className="modal-header">
                <h4 className="modal-title fs-20">{t("userAddButton")}</h4>
                <button
                  type="button"
                  className="close btn"
                  onClick={onHideModal}
                >
                  <span>×</span>
                </button>
              </div>
              <div className="modal-body">
                <i
                  className="flaticon-cancel-12 close"
                  data-dismiss="modal"
                ></i>
                <div className="add-contact-box">
                  <div className="add-contact-content">
                    <div
                      className={`form-group ${
                        createTriggered && firstname === "" ? "" : "mb-3"
                      }`}
                    >
                      <label className="mb-1">
                        <span className="text-danger">*</span>
                        &ensp;
                        <strong>{t("firstnameInput")}</strong>
                      </label>
                      <input
                        type="text"
                        placeholder={t("firstnamePlaceholder")}
                        className="form-control"
                        value={firstname}
                        onChange={(e) => setFirstname(e.target.value)}
                        disabled={!isObjectEmpty(viewData)}
                      />
                    </div>
                    {createTriggered && firstname === "" && (
                      <div className="text-danger fs-12">
                        {t("firstnamePlaceholder")} {t("globalIsRequired")}
                      </div>
                    )}
                    <div
                      className={`form-group ${
                        createTriggered && lastname === "" ? "" : "mb-3"
                      }`}
                    >
                      <label className="mb-1">
                        <span className="text-danger">*</span>
                        &ensp;
                        <strong>{t("lastnameInput")}</strong>
                      </label>
                      <input
                        type="text"
                        placeholder={t("lastnamePlaceholder")}
                        className="form-control"
                        value={lastname}
                        onChange={(e) => setLastname(e.target.value)}
                        disabled={!isObjectEmpty(viewData)}
                      />
                    </div>
                    {createTriggered && lastname === "" && (
                      <div className="text-danger fs-12">
                        {t("lastnamePlaceholder")} {t("globalIsRequired")}
                      </div>
                    )}
                    <div
                      className={`form-group ${
                        createTriggered && username === "" ? "" : "mb-3"
                      }`}
                    >
                      <label className="mb-1">
                        <span className="text-danger">*</span>
                        &ensp;
                        <strong>{t("usernameInput")}</strong>
                      </label>
                      <input
                        type="text"
                        placeholder={t("usernamePlaceholder")}
                        className="form-control"
                        value={username}
                        autoComplete="off"
                        onChange={(e) => setUsername(e.target.value)}
                        disabled={!isObjectEmpty(viewData)}
                      />
                    </div>
                    {createTriggered && username === "" && (
                      <div className="text-danger fs-12">
                        {t("usernamePlaceholder")} {t("globalIsRequired")}
                      </div>
                    )}
                    <div
                      className={`form-group ${
                        createTriggered && idRole === "" ? "" : "mb-3"
                      }`}
                    >
                      <label className="mb-1">
                        <span className="text-danger">*</span>
                        &ensp;
                        <strong>{t("roleInput")}</strong>
                      </label>
                      <div className="basic-dropdown">
                        <select
                          className="form-control"
                          style={{ border: "1px solid #EEEEEE" }}
                          onChange={(e) => setIdRole(e.target.value)}
                          value={idRole}
                          disabled={!isObjectEmpty(viewData)}
                        >
                          <option value="">Select</option>
                          {allRoles?.map((item, index) => (
                            <option value={item.id} key={index}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {idRole === "5" && (
                      <div className="form-group mb-3">
                        <label className="mb-1">
                          <span className="text-danger">*</span>
                          &ensp;
                          <strong>Profession</strong>
                        </label>
                        <select
                          className="form-control"
                          style={{ border: "1px solid #EEEEEE" }}
                          value={profession}
                          onChange={(e) => setProfession(e.target.value)}
                        >
                          <option value="">{t("globalSelect")}</option>
                          <option value="Real Estate Broker">
                            {t("hbroker")}
                          </option>
                          <option value="Finance Broker">
                            {t("hbrokerFinance")}
                          </option>
                          <option value="Lawyer">{t("hlawyer")}</option>
                          <option value="IT Consulting">{t("hit")}</option>
                        </select>
                      </div>
                    )}
                    {createTriggered && idRole === "" && (
                      <div className="text-danger fs-12">
                        {t("roleInput")} {t("globalIsRequired")}
                      </div>
                    )}
                    <div
                      className={`form-group ${
                        createTriggered && password === "" ? "" : "mb-3"
                      }`}
                    >
                      <label className="mb-1 ">
                        <span className="text-danger">*</span>
                        &ensp;
                        <strong>{t("passwordInput")}</strong>
                      </label>
                      <input
                        type="password"
                        placeholder={t("passwordPlaceholder")}
                        className="form-control"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        disabled={!isObjectEmpty(viewData)}
                        autoComplete="off"
                      />
                    </div>
                    {createTriggered && password === "" && (
                      <div className="text-danger fs-12">
                        {t("passwordPlaceholder")} {t("globalIsRequired")}
                      </div>
                    )}
                    <div
                      className={`form-group ${
                        createTriggered && confirmPwd === "" ? "" : "mb-3"
                      }`}
                    >
                      <label className="mb-1 ">
                        <span className="text-danger">*</span>
                        &ensp;
                        <strong>{t("confirmPasswordInput")}</strong>
                      </label>
                      <input
                        type="password"
                        placeholder={t("confirmPasswordPlaceholder")}
                        className="form-control"
                        value={confirmPwd}
                        onChange={(e) => setConfirmPwd(e.target.value)}
                        disabled={!isObjectEmpty(viewData)}
                      />
                    </div>
                    {createTriggered && confirmPwd === "" && (
                      <div className="text-danger fs-12">
                        {t("confirmPasswordPlaceholder")}{" "}
                        {t("globalIsRequired")}
                      </div>
                    )}
                    {createTriggered &&
                      confirmPwd !== "" &&
                      confirmPwd !== password && (
                        <div className="text-danger fs-12">
                          {t("hconfirmPass")}
                        </div>
                      )}
                    <div className="form-group mb-3">
                      <label className="mb-1">
                        <strong>{t("phoneInput")}</strong>
                      </label>
                      <input
                        type="text"
                        placeholder={t("phonePlaceholder")}
                        className="form-control"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        disabled={!isObjectEmpty(viewData)}
                      />
                    </div>
                    <div className="form-group ">
                      <label className="mb-1">
                        {" "}
                        <span className="text-danger">*</span>
                        &ensp;
                        <strong>{t("emailInput")}</strong>
                      </label>
                      <input
                        type="email"
                        placeholder={t("emailPlaceholder")}
                        className="form-control"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={!isObjectEmpty(viewData)}
                      />
                    </div>
                    {createTriggered && idRole === "" && (
                      <div className="text-danger fs-12 mb-3">
                        {t("emailInput")} {t("globalIsRequired")}
                      </div>
                    )}
                    <div className="form-group mb-3">
                      <label className="mb-1">
                        <strong>{t("photoInput")}</strong>
                      </label>
                      <input
                        type="file"
                        accept=".jpg, .jpeg, .png"
                        className="form-control"
                        ref={fileInputRef}
                        onChange={onChangePhoto}
                        disabled={!isObjectEmpty(viewData)}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="mb-1">
                        <strong>{t("addressInput")}</strong>
                      </label>
                       <StandaloneSearchBox onLoad={(ref) => (searchBoxRef.current = ref)} onPlacesChanged={handlePlacesChanged}>
                        <input
                          type="text"
                          placeholder={t("addressPlaceholder")}
                          className="form-control"
                          value={addressInput}
                           disabled={!isObjectEmpty(viewData)}
                           onChange={(e) => {
                              const newAddress = e.target.value;
                              setAddressInput(newAddress);
                              setAddress(newAddress);
                              setCity("");
                              setCountry("");
                            }
                          }
                        />
                      </StandaloneSearchBox>

                      {/* <input
                        type="text"
                        placeholder={t("addressPlaceholder")}
                        className="form-control"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        disabled={!isObjectEmpty(viewData)}
                      /> */}
                    </div>
                    <div className="form-group mb-3">
                      <label className="mb-1">
                        <strong>{t("cityInput")}</strong>
                      </label>
                      <input
                        type="text"
                        placeholder={t("cityPlaceholder")}
                        className="form-control"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        disabled={!isObjectEmpty(viewData)}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="mb-1">
                        <strong>{t("countryInput")}</strong>
                      </label>
                      <input
                        type="text"
                        placeholder={t("countryPlaceholder")}
                        className="form-control"
                        value={country}
                        onChange={(e) => setCountry(e.target.value)}
                        disabled={!isObjectEmpty(viewData)}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="mb-1">
                        <span className="text-danger">*</span>
                        &ensp;
                        <strong>{t("hotherInterests")}</strong>
                      </label>
                      <select
                        className="form-control"
                        style={{ border: "1px solid #EEEEEE" }}
                        onChange={onInterestChangeHandler}
                      >
                        <option value="">{t("globalSelect")}</option>
                        {otherInterest?.map((item, index) => (
                          <option value={item.label} key={index}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    {isIterestItemsShow && (
                      <div className="form-group mb-3">
                        <label className="mb-1">
                          <strong>{t("harea")}</strong>
                        </label>
                        <MultiSelect
                          hasSelectAll={false}
                          disableSearch={false}
                          options={subInterest}
                          value={selectedSubInterest}
                          onChange={setSelectedSubInterest}
                          labelledBy="Select"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                {isObjectEmpty(viewData) && (
                  <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={(e) =>
                      addUserHandler(e, isObjectEmpty(updateData))
                    }
                  >
                    {isObjectEmpty(updateData)
                      ? `${t(`globalAddButton`)}`
                      : `${t(`globalUpdateButton`)}`}
                  </button>
                )}
                <button
                  type="button"
                  onClick={onHideModal}
                  className="btn btn-light"
                >
                  <i className="flaticon-delete-1"></i>
                  &nbsp; {t("globalDiscardButton")}
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <Modal
        className="modal fade"
        show={changePwdModal.cond}
        onHide={onHideChangePwdModal}
      >
        <div className="" role="document">
          <div className="">
            <form>
              <div className="modal-header">
                <h4 className="modal-title fs-20 text-primary">
                  {t("changePassword")}
                </h4>
                <button
                  type="button"
                  className="close btn"
                  onClick={onHideChangePwdModal}
                >
                  <span>×</span>
                </button>
              </div>
              <div className="modal-body">
                <i
                  className="flaticon-cancel-12 close"
                  data-dismiss="modal"
                ></i>
                <div className="add-contact-box">
                  <div className="add-contact-content">
                    <div
                      className={`form-group ${
                        changePwdTrigger && changePwd.oldPwd === ""
                          ? ""
                          : "mb-3"
                      }`}
                    >
                      <label className="mb-1">
                        <strong>{t("changePasswordOldPassword")}</strong>
                        <span className="text-danger">*</span>
                      </label>
                      <div className="form-group">
                        <div className="input-group">
                          <input
                            type={showPwd ? "text" : "password"}
                            placeholder={t("changePasswordOldPassword")}
                            className="form-control"
                            value={changePwd.oldPwd}
                            onChange={(e) =>
                              updateChangePwd("oldPwd", e.target.value)
                            }
                          />
                          <div className="input-group-append ">
                            <span
                              className="input-group-text form-control"
                              style={{ cursor: "pointer", color: "#6c757d" }}
                              onClick={() => setShowPwd(!showPwd)}
                            >
                              <i
                                className={`fa ${
                                  showPwd ? "fa-eye-slash" : "fa-eye"
                                }`}
                              ></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {changePwdTrigger && changePwd.oldPwd === "" && (
                      <div className="text-danger fs-12">
                        {t("changePasswordOldPassword")} {t("globalIsRequired")}
                      </div>
                    )}
                    <div
                      className={`form-group ${
                        changePwdTrigger && lastname === "" ? "" : "mb-3"
                      }`}
                    >
                      <label className="mb-1">
                        <strong>{t("changePasswordNewPassword")}</strong>
                        <span className="text-danger">*</span>
                      </label>
                      <div className="form-group">
                        <div className="input-group">
                          <input
                            className="form-control"
                            type={showNewPwd ? "text" : "password"}
                            placeholder={t("changePasswordNewPassword")}
                            autoComplete="off"
                            value={changePwd.newPwd}
                            onChange={(e) =>
                              updateChangePwd("newPwd", e.target.value)
                            }
                          />
                          <div className="input-group-append">
                            <span
                              className="input-group-text form-control"
                              style={{ cursor: "pointer", color: "#6c757d" }}
                              onClick={() => setShowNewPwd(!showNewPwd)}
                            >
                              <i
                                className={`fa ${
                                  showNewPwd ? "fa-eye-slash" : "fa-eye"
                                }`}
                              ></i>
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* <div className="form-group">
                      <div className="input-group">
                          <input className="form-control" type="password"  placeholder={t("changePasswordNewPassword")} id="loginPwd" autocomplete="off"  value={changePwd.newPwd}  onChange={(e) => updateChangePwd("newPwd", e.target.value) }/>
                          <div className="input-group-append">
                              <span style={{cursor: "pointer"}} class="input-group-text" id="addonEye"><i class="fa fa-eye"></i></span>
                          </div>
                      </div>
                    </div> */}
                    </div>
                    {changePwdTrigger && changePwd.newPwd === "" && (
                      <div className="text-danger fs-12">
                        {t("changePasswordNewPassword")} {t("globalIsRequired")}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  onClick={onHideChangePwdModal}
                  className="btn btn-custom"
                  style={{ backgroundColor: "#9c9c9cff", color: "black" }}
                >
                  <i className="flaticon-delete-1"></i>
                  &nbsp;{t("globalDiscardButton")}
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={changePwdhandler}
                >
                  {t("changePasswordButton")}
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <div class="card">
        <div class="card-header d-sm-flex d-block">
          <div class="me-auto mb-sm-0">
            <h4 class="card-title">{t("userTitle")}</h4>
          </div>

          <div style={{ paddingLeft: "12px" }}>
            <a
              href="javascript:void(0);"
              class="btn btn-primary"
              onClick={onAddUser}
            >
              + {t("userAddButton")}
            </a>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div
              class="col-sm-12 col-md-4 col-lg-4"
              style={{ gridColumnEnd: "-1" }}
            >
              <GlobalFilter filter={gridFilter} setFilter={updateGridFilter} />
            </div>
          </div>
          <div class="table-responsive">
            <table class="table style-1" id="ListDatatableView">
              <thead>
                <tr>
                  <th>{t("userCollumn1")}</th>
                  <th>{t("userCollumn2")}</th>
                  <th>{t("userCollumn3")}</th>
                  <th>{t("userCollumn4")}</th>
                  <th>{t("userCollumn5")}</th>
                  <th>{t("userCollumn6")}</th>
                  <th>{t("userCollumn7")}</th>
                </tr>
              </thead>

              <tbody>
                {usersList.filtered.map((data, index) => {
                  const dateObject = new Date(data?.createdat);

                  const month = (dateObject.getMonth() + 1)
                    .toString()
                    .padStart(2, "0");
                  const day = dateObject.getDate().toString().padStart(2, "0");
                  const year = dateObject.getFullYear();

                  const formattedDate = `${month}/${day}/${year}`;

                  return (
                    <tr>
                      <td>
                        <h6>
                          {tableParams.current
                            ? index +
                              1 +
                              (tableParams.current - 1) * tableParams.pageSize
                            : index + 1}
                          .
                        </h6>
                      </td>
                      <td>
                        <div class="media style-1">
                          <div class="media-body">
                            <h6>{data?.username}</h6>
                            <span>{data?.email}</span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div>
                          <h6>{data?.country || "NA"}</h6>
                        </div>
                      </td>
                      <td>
                        <div>
                          <h6 class="text-primary">{formattedDate}</h6>
                        </div>
                      </td>
                      <td>{data?.role}</td>
                      <td>
                        <div className="d-flex align-items-center w-100">
                          <Form.Check
                            type="switch"
                            id="custom-switch"
                            style={{ marginRight: "8px" }}
                            checked={Boolean(data?.isactive)}
                            onChange={() =>
                              onChangeStatus(data?.id, data?.isactive)
                            }
                          />
                          <span
                            class={`badge light ${
                              data.isactive === true
                                ? "badge-success"
                                : "badge-danger"
                            }`}
                          >
                            {data.isactive === true ? "Active" : "Inactive"}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex action-button">
                          <a
                            href="javascript:void(0);"
                            class="btn btn-info btn-xs light px-2"
                            style={{ fontSize: "15px", marginRight: "8px" }}
                            onClick={() => onViewUser(data)}
                          >
                            <i className="fa fa-eye"></i>
                          </a>
                          <a
                            href="javascript:void(0);"
                            class="btn btn-info btn-xs light px-2"
                            onClick={() => onUpdateUser(data)}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17 3C17.2626 2.73735 17.5744 2.52901 17.9176 2.38687C18.2608 2.24473 18.6286 2.17157 19 2.17157C19.3714 2.17157 19.7392 2.24473 20.0824 2.38687C20.4256 2.52901 20.7374 2.73735 21 3C21.2626 3.26264 21.471 3.57444 21.6131 3.9176C21.7553 4.26077 21.8284 4.62856 21.8284 5C21.8284 5.37143 21.7553 5.73923 21.6131 6.08239C21.471 6.42555 21.2626 6.73735 21 7L7.5 20.5L2 22L3.5 16.5L17 3Z"
                                stroke="#fff"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>
                            </svg>
                          </a>
                          <a
                            href="javascript:void(0);"
                            class="ms-2 btn btn-xs px-2 light btn-danger"
                            style={{ marginRight: "8px" }}
                            onClick={() => onDeleteUser(data?.id)}
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3 6H5H21"
                                stroke="#fff"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>
                              <path
                                d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
                                stroke="#fff"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              ></path>
                            </svg>
                          </a>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="success"
                              disabled={loadingResetPwd}
                              className="light sharp i-false"
                            >
                              {loadingResetPwd && resetPwdIndex === data?.id ? (
                                <div>
                                  <Spinner animation="border" />
                                </div>
                              ) : (
                                <svg
                                  width="20px"
                                  height="20px"
                                  viewBox="0 0 24 24"
                                  version="1.1"
                                >
                                  <g
                                    stroke="none"
                                    strokeWidth="1"
                                    fill="none"
                                    fillRule="evenodd"
                                  >
                                    <rect
                                      x="0"
                                      y="0"
                                      width="24"
                                      height="24"
                                    ></rect>
                                    <circle
                                      fill="#000000"
                                      cx="5"
                                      cy="12"
                                      r="2"
                                    ></circle>
                                    <circle
                                      fill="#000000"
                                      cx="12"
                                      cy="12"
                                      r="2"
                                    ></circle>
                                    <circle
                                      fill="#000000"
                                      cx="19"
                                      cy="12"
                                      r="2"
                                    ></circle>
                                  </g>
                                </svg>
                              )}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {/* <Dropdown.Item
                                onClick={() => onChangePwd(data?.id)}
                              >
                                Change Password
                              </Dropdown.Item> */}
                              {(ctxObj?.result?.role?.id === 2 ||
                                ctxObj?.result?.role?.id === 1) && (
                                <Dropdown.Item
                                  onClick={() => onResetPwd(data?.id)}
                                >
                                  {t("hresetpass")}
                                </Dropdown.Item>
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div>
            <div className="d-flex justify-content-end align-items-center">
              <Pagination
                current={tableParams.current}
                pageSize={tableParams.pageSize}
                total={tableParams.total}
                onChange={onChangePagination}
                showSizeChanger={true}
                pageSizeOptions={[10, 20, 30, 40, 50]}
                simple={true}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Users;
